export default __webpack_public_path__ + "static/media/banner.85cfdae8.png";